// src/index.js
import { createRoot } from 'react-dom/client'
import './styles.css'
import { App } from './App'
import Particles from './Particles'

function Root() {
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* Particles background */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
        <Particles
          particleColors={['#ffffff']}   // white particles
          particleCount={250}
          particleSpread={8}
          speed={0.2}
          particleBaseSize={80}
          moveParticlesOnHover={true}
          alphaParticles={false}
        />
      </div>

      {/* App content above */}
      <div style={{ position: 'relative', zIndex: 1, width: '100%', height: '100%' }}>
        <App />
      </div>
    </div>
  )
}

createRoot(document.getElementById('root')).render(<Root />)
